import React from "react";
import { connect } from "react-redux";
import { selectIsPLGAccount, selectUser } from "../../../../store/userSelectors";
import {
    NEXT_LAUNCHPAD_TARGETS,
    isNextLaunchpadRefinementsEnabledForUser,
    openNextLaunchpad,
} from "../../../../util/nextLaunchpad";
import "../../../Modal/dialog.css";
class Modal extends React.Component {
    state = {
        improveConversationLoading: false,
    };

    handleImproveConversation = async () => {
        const { user } = this.props;

        if (!isNextLaunchpadRefinementsEnabledForUser({ user })) {
            return;
        }

        this.setState({ improveConversationLoading: true });

        try {
            await openNextLaunchpad({
                user,
                target: NEXT_LAUNCHPAD_TARGETS.PARTNER_REFINEMENTS,
            });
        } catch (err) {
            console.error("Error opening AI Receptionist refinements:", err);
            alert("AI Launchpad is not available right now. Please try again.");
            this.setState({ improveConversationLoading: false });
        }
    };

    render() {
        let brnparse = this.props.parsebtn == true ? "parseparent" : "";
        const centeredTitles = [
            'Change your subscription?',
            'Choose Your Subscription Plan',
            'Confirm Add-on Package Selection',
            'Confirm Add-On Package Selection'
        ];
        const isCenteredTitle = centeredTitles.includes(this.props.title);
        const isWebhookData = this.props.title === "Webhook Data";
        const showTrainingActions = this.props.modaltranscript && this.props.isgpt == 1 && !isWebhookData;

        return (
            <React.Fragment>
                <div
                    className="ui loading form mh-loading-custom"
                    style={{ display: this.state.improveConversationLoading ? 'block' : 'none' }}
                />
                <div
                    className={this.props.show ? "modal completedchats fade show" : "modal completedchats fade"}
                    data-backdrop="static"
                    tabIndex="-1"
                    role="dialog"
                    data-keyboard="false"
                    aria-labelledby="staticBackdrop"
                    aria-hidden="true"
                    style={{ display: this.props.show ? "block" : "none", zIndex: this.props.modelindex ?? '999' }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: this.props.maxWidth || 600 }}>
                        {this.props.loading && <div className="ui loading form"></div>}
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close linear-gradient"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => this.props.onclose()}
                                style={{ zIndex: this.props.modelindex ?? '999' }}
                            >
                                X
                            </button>
                            <div
                                className={[
                                    'modal-header',
                                    this.props.title ? this.props.title.replace(/\s/g, '') : '',
                                    this.props.headerClassName || '',
                                ].filter(Boolean).join(' ')}
                                style={{
                                    justifyContent: isCenteredTitle ? 'center' : 'flex-start',
                                }}
                            >
                                <h5
                                    className="modal-title"
                                    style={{
                                        fontSize: '1.6rem',
                                        fontFamily: 'Lato,Helvetica Neue,Arial,Helvetica,sans-serif',
                                        textAlign: isCenteredTitle ? 'center' : 'left',
                                        width: isCenteredTitle ? '100%' : 'auto',
                                        fontWeight: isCenteredTitle ? 'bold' : 'normal',
                                    }}
                                >
                                    {this.props.title}
                                </h5>


                                {this.props.modaltranscript && !this.props.hideSmsTranscriptControls && !isWebhookData && this.props.modaltranscript}
                            </div>


                            <div className='modal-body parsedatap viewemail' style={{ paddingTop: "10px" }}>
                                <div style={{ marginLeft: "-5px" }}>
                                    {this.props?.custom_search && Object.keys(this.props?.parsed_data).length > 0 && !this.props?.title && this.props?.custom_search?.status == 'ON' && <div className="send-button">
                                        <button className={this.props.parsebtnName + " btn linear-gradient yr-add-new  onclick "} onClick={() => this.props.openCustomPopup(this.props?.custom_serach)} data-toggle="modal" style={{ boxShadow: 'none' }}>{this.props.custom_search.button_name}
                                        </button></div>}
                                    {this.props.title == "View email list" ? <div style={{ overflowWrap: "break-word", whiteSpace: "break-spaces" }}>{this.props.body}</div> : <>{this.props.body}</>}
                                    <div
                                        className="d-flex align-items-center"
                                        style={{
                                            marginTop: '20px',
                                            width: '100%',
                                            justifyContent: showTrainingActions ? 'space-between' : 'flex-end',
                                        }}
                                    >
                                        {showTrainingActions && this.props.isPLG && (
                                            <button
                                                type="button"
                                                className="btn linear-gradient yr-add-new onclick"
                                                onClick={this.handleImproveConversation}
                                                disabled={this.state.improveConversationLoading}
                                                style={{ height: '44px', lineHeight: '1.3rem', boxShadow: 'none', margin: 0 }}
                                            >
                                                Improve My Conversation
                                            </button>
                                        )}
                                        {showTrainingActions && !this.props.isPLG && (
                                            <button type="button" className="btn linear-gradient yr-add-new red onclick" onClick={() => this.props.showtrainlogModal(this.props.auto_id)} data-toggle="modal" style={{ height: '44px', lineHeight: '1.3rem', background: 'red', boxShadow: 'none', margin: 0 }}>{this.props.isSmsMode ? "Report This SMS Conversation For Training" : "Report This Chat/Voice For Training"} {this.props?.custom_serach?.status}</button>
                                        )}
                                        {(this.props.modaltranscript && !this.props.hideSmsTranscriptControls && !isWebhookData) && <button type="button" className="btn linear-gradient yr-add-new onclick leaveinternalnotes" onClick={() => this.props.showNotesForm(this.props.auto_id)} style={{ height: '44px', lineHeight: '1.3rem', boxShadow: 'none', margin: 0 }}>Leave Internal Notes</button>}
                                        {this.props.footer}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

const mapStateToProps = (state) => ({
    isPLG: selectIsPLGAccount(state),
    user: selectUser(state),
});

export default connect(mapStateToProps)(Modal);
